module.exports = __webpack_public_path__ + "static/media/train.55e60716.jpg";